import { rowsType } from '.'

export const mountInterventionInfo = (
    intervention: Intervention,
    wellIndex: number
): {
    wellIndex: number
    type: RowType
    name: string
    begin: string
    end: string
} => {
    const runs = intervention?.part?.sections?.reduce((acc, curr) => {
        return curr?.runs?.length > 0 && [...acc, ...curr?.runs]
    }, []) as Run[]

    const interventionInfo =
        runs?.length > 0
            ? {
                  wellIndex: wellIndex,
                  type: rowsType[0],
                  name: intervention?.name || 'INTERVENTION',
                  begin: Math.min(...runs?.map(r => r?.start))?.toString(),
                  end: Math.max(...runs?.map(r => r?.end ?? new Date().getTime()))?.toString()
              }
            : {
                  wellIndex: wellIndex,
                  type: rowsType[0],
                  name: intervention?.name || 'INTERVENTION',
                  begin: intervention?.begin?.toString(),
                  end: intervention?.end?.toString() ?? new Date().getTime()
              }
    return interventionInfo
}
